import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setSidebarOpen(!mobile);
    };
    window.addEventListener("resize", onResize);
    onResize();
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div>
      {/* Ahora sí pasamos isMobile */}
      <Navbar notificaciones={0} isMobile={isMobile} />

      <div className="flex pt-14">
        <Sidebar open={sidebarOpen} toggle={() => setSidebarOpen(o => !o)} />
        <main
          className={`transition-all duration-300 bg-gradient-to-br from-blue-200 via-blue-100 to-blue-50 min-h-screen w-full ${isMobile ? "ml-16" : sidebarOpen ? "ml-64" : "ml-16"
            }`}
        >
          <div className="p-4">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
